import Http from "@/config/axios.js"
import {to} from "await-to-js"

export default {
    async index(params = {}) {
        return to(Http.get(`/timezones`, {params}))
    }
}

